module.exports = __webpack_public_path__ + "images/msg_card_urgent.d45d71ae90f78746da8c2b42c5a5e390.png";